import { motion } from "framer-motion";
import { Wallet } from "lucide-react";
import { useEffect, useState } from "react";
import { Card, CardContent } from "../../../../components/ui/card";
import { useToast } from "../../../../hooks/use-toast";
import { config } from "../../../../utils/config";
import { ResultsSection } from "./components/results-section";
import { SearchForm } from "./components/search-form";
import { useSaldoConsulta } from "./hooks/use-saldo-consulta";

export default function SaldoConsulta() {
  const fundName = `xama_${config.stage}`;
  const { toast } = useToast();

  const {
    searchForm,
    searchResults,
    fieldErrors,
    handleFieldChange,
    handleSearch,
    isSearching,
  } = useSaldoConsulta({ fundName });

  const handleSearchClick = () => {
    if (!fundName) {
      toast({
        title: "Fundo não selecionado",
        description: "Selecione um fundo antes de continuar",
        variant: "destructive",
      });
      return;
    }

    const result = handleSearch();
    if (!result.valid && result.message) {
      toast({
        title: "Erro de validação",
        description: result.message,
        variant: "destructive",
      });
    }
  };

  return (
    <div className="p-6">
      <motion.div
        className="mb-6"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <div className="flex items-center justify-between">
          <div className="space-y-1">
            <div className="flex items-center gap-3">
              <motion.div
                className="p-2 rounded-lg bg-primary/10"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
              >
                <Wallet className="h-6 w-6 text-primary" />
              </motion.div>
              <h1 className="text-3xl font-bold text-foreground bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                Consulta de Saldo - Entregadores
              </h1>
            </div>
            <p className="text-muted-foreground mt-1 ml-14">
              Consulte o saldo dos entregadores por telefone, CPF ou CNPJ
            </p>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="space-y-6"
      >
        <Card className="border-2 hover:border-primary/50 transition-colors">
          <CardContent className="pt-6">
            <SearchForm
              searchForm={searchForm}
              onFieldChange={handleFieldChange}
              onSearch={handleSearchClick}
              isSearching={isSearching}
              fundName={fundName}
              fieldErrors={fieldErrors}
            />
            </CardContent>
        </Card>

        {searchResults && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            <ResultsSection cadastros={searchResults} />
          </motion.div>
        )}
      </motion.div>
    </div>
  );
}
